import { render } from "./MenuHeader.vue?vue&type=template&id=cb9ff21a&scoped=true"
import script from "./MenuHeader.vue?vue&type=script&lang=js"
export * from "./MenuHeader.vue?vue&type=script&lang=js"

import "./MenuHeader.vue?vue&type=style&index=0&id=cb9ff21a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb9ff21a"]])

export default __exports__